export enum ReactionTypes {
  NORMALIZING = "I can relate",
  COMFORTING = "Big hug!",
  NOTICING = "Glad you shared",
  HELPING = "How can I help?",
  SUPPORTING = "With you on that",
  LAUGHING = "Laughing with you",
  RECOGNIZING = "That's Awesome!"
}
